import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCountry } from '../context/CountryContext';
import { useLanguage } from '../i18n/LanguageContext';
import CountryPill from './CountryPill';

// NULA MOVE · ADMIN navigation restructure (Ikram's spec) — global bar,
// always visible: page title + breadcrumb, country selector, notifications,
// profile menu (My account / Language / Log out — Log out moved OUT of the
// sidebar and into this menu, per the spec).
const GlobalBar = ({ title, onMenuToggle }) => {
  const { user, logout } = useAuth();
  const { country, setCountry, availableOptions, locked, isReadOnly } = useCountry();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [profileOpen, setProfileOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <header style={s.bar}>
      <button style={s.menuToggle} onClick={onMenuToggle} aria-label="Toggle menu">☰</button>

      <div style={s.titleArea}>
        <span style={s.breadcrumb}>NULA MOVE · ADMIN</span>
        <h1 style={s.title}>{title}</h1>
      </div>

      <div style={s.searchBox} title="Search (Cmd/Ctrl+K) — coming in a later phase">
        <span>🔍</span>
        <span style={s.searchPlaceholder}>Search… (⌘K)</span>
      </div>

      <CountryPill
        value={country}
        options={availableOptions}
        onChange={setCountry}
        disabled={locked && availableOptions.length <= 1}
      />
      {isReadOnly && <span style={s.readOnlyBadge}>{t('Read-only')}</span>}

      <button style={s.bellBtn} title="Notifications">🔔</button>

      <div style={s.profileWrap}>
        <button style={s.profileBtn} onClick={() => setProfileOpen((v) => !v)}>
          <span style={s.avatar}>{(user?.full_name || user?.email || '?')[0].toUpperCase()}</span>
        </button>
        {profileOpen && (
          <>
            <div style={s.profileBackdrop} onClick={() => setProfileOpen(false)} />
            <div style={s.profileMenu}>
              <div style={s.profileName}>{user?.full_name || 'Admin'}</div>
              <div style={s.profileEmail}>{user?.email}</div>
              <button style={s.profileItem} onClick={() => { setProfileOpen(false); navigate('/my-account'); }}>{t('My account')}</button>
              <button style={{ ...s.profileItem, color: '#dc2626' }} onClick={handleLogout}>🚪 {t('Log out')}</button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

const s = {
  bar: { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', background: 'white', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 20, flexWrap: 'wrap' },
  menuToggle: { background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', flexShrink: 0 },
  titleArea: { display: 'flex', flexDirection: 'column', marginRight: 'auto', minWidth: 120 },
  breadcrumb: { fontSize: 10.5, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.04em' },
  title: { fontSize: 16, fontWeight: 800, color: '#111827', margin: 0 },
  searchBox: { display: 'flex', alignItems: 'center', gap: 6, padding: '6px 10px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#f9fafb', fontSize: 12.5, color: '#9ca3af', cursor: 'not-allowed' },
  searchPlaceholder: { whiteSpace: 'nowrap' },
  countrySelect: { padding: '6px 8px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 12.5, background: 'white' },
  readOnlyBadge: { fontSize: 10.5, fontWeight: 700, color: '#92400e', background: '#fef9c3', padding: '3px 8px', borderRadius: 999 },
  bellBtn: { background: 'none', border: 'none', fontSize: 16, cursor: 'pointer' },
  profileWrap: { position: 'relative' },
  profileBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 0 },
  avatar: { width: 32, height: 32, borderRadius: '50%', background: '#0B6A4A', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 },
  profileBackdrop: { position: 'fixed', inset: 0, zIndex: 25 },
  profileMenu: { position: 'absolute', right: 0, top: 40, background: 'white', border: '1px solid #e5e7eb', borderRadius: 10, boxShadow: '0 10px 30px rgba(0,0,0,0.12)', padding: 10, width: 200, zIndex: 30 },
  profileName: { fontSize: 13, fontWeight: 700, color: '#111827', padding: '4px 8px' },
  profileEmail: { fontSize: 11.5, color: '#9ca3af', padding: '0 8px 8px', borderBottom: '1px solid #f3f4f6', marginBottom: 6 },
  profileItem: { display: 'block', width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '8px', borderRadius: 6, fontSize: 13, cursor: 'pointer', color: '#374151' },
};

export default GlobalBar;
